import { render, staticRenderFns } from "./CoursesListAdminView.vue?vue&type=template&id=5a7ffe23&"
import script from "./CoursesListAdminView.vue?vue&type=script&lang=ts&"
export * from "./CoursesListAdminView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports